import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../base/dtos/base.dto';
import { VehicleModelListDto } from '../../vehicle-models/dtos/vehicle-model-list.dto';

/**
 * Vehicle make DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleMakeListDto extends BaseDto {
	name!: string;
	externalReference?: string;
	models?: VehicleModelListDto[];

	mobileTitle = (): string | null => {
		return `${this.name}`;
	};

	mobileSubtitle = (): string | null => {
		return '';
	};
}
